// must be the same as STORAGE_KEY in fritsAuthInterceptors;
export const STORAGE_KEY = 'fritsauthentication';
